import { render, staticRenderFns } from "./VaccineCoveragePanel.vue?vue&type=template&id=8e5e6784&scoped=true&"
import script from "./VaccineCoveragePanel.vue?vue&type=script&lang=js&"
export * from "./VaccineCoveragePanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccineCoveragePanel.vue?vue&type=style&index=0&id=8e5e6784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5e6784",
  null
  
)

export default component.exports